import React from 'react'
import Redirect from '#src/components/Redirect'
import { loginLocation, LoginLocationOptions } from '#src/services/routing'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import { withStatusCode } from '#src/containers/Router'
import { Button } from '@deal/components'
import BrandAwareLogo from '#src/components/Logo'
import styles from './styles.css'

interface Props {
  redirectToLogin?: boolean
  loginLocationOptions?: LoginLocationOptions
}

const Unauthorized: React.SFC<Props & RouteComponentProps> = ({
  location,
  redirectToLogin = true,
  loginLocationOptions
}) => {
  if (redirectToLogin) {
    return <Redirect to={loginLocation(location, loginLocationOptions)} />
  } else {
    return (
      <section>
        <header className={styles.header}>
          <Link to="/" className={styles.logo}>
            <BrandAwareLogo mark="combo" color="dark" className={styles.desktopIcon} />
            <BrandAwareLogo mark="icon" color="dark" className={styles.mobileIcon} />
          </Link>
        </header>
        <div className={styles.code}>401</div>
        <h1 className={styles.headline}>You do not have access to this page.</h1>
        <div className={styles.button}>
          <Link to={loginLocation(location)}>
            <Button className={styles.darkButton}>Take me home</Button>
          </Link>
        </div>
      </section>
    )
  }
}

export default withStatusCode<Props>(401)(withRouter(Unauthorized))
